import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import useDateRangeFilter from "../portlibs/DateRangeFilterProvider";

export default function(){
    const {start,end,setStart,setEnd} = useDateRangeFilter()
    return <div className="flex2 dates flex gap-16">
        <DatePicker className="flex1" label="Start" value={start} onChange={(e:dayjs.Dayjs|null)=>e&&setStart(e)}/>
        <DatePicker className="flex1" label="End" value={end} onChange={(e:dayjs.Dayjs|null)=>e&&setEnd(e)}/>
    </div>
}